"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "../ui/carousel";
import { BlogCard } from "./blog-card";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { SliderPagination } from "./slider-pagination";
const formatBlogDate = (dateStr?: string) => {
  if (!dateStr) return "";
  try {
    // Safely extract "YYYY-MM-DD" regardless of 'T' or space separations
    const cleanDate = dateStr.substring(0, 10);
    const dateSubparts = cleanDate.split("-");
    if (dateSubparts.length !== 3) return dateStr;
    const year = dateSubparts[0];
    const month = dateSubparts[1];
    const day = dateSubparts[2];
    if (!year || !month || !day) return dateStr;
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthIndex = parseInt(month, 10) - 1;
    if (monthIndex < 0 || monthIndex > 11) return dateStr;
    return `${day} ${months[monthIndex]} ${year}`;
  } catch {
    return dateStr || "";
  }
};
type BlogSliderProps = {
  data?: Post[];
};
export const BlogSlider = t0 => {
  const $ = _c(21);
  const {
    data: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  const [api, setApi] = useState();
  const [current, setCurrent] = useState(0);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [count, setCount] = useState(data.length);
  let t3;
  let t4;
  if ($[2] !== api) {
    t3 = () => {
      if (!api) {
        return;
      }
      const updateState = () => {
        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap());
        setCanScrollPrev(api.canScrollPrev());
        setCanScrollNext(api.canScrollNext());
      };
      updateState();
      api.on("select", updateState);
      api.on("reInit", updateState);
      return () => {
        api.off("select", updateState);
        api.off("reInit", updateState);
      };
    };
    t4 = [api];
    $[2] = api;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      align: "start",
      loop: true,
      slidesToScroll: "auto",
      skipSnaps: true
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== data) {
    t6 = data.map(_temp);
    $[6] = data;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <Carousel className="w-full" setApi={setApi} opts={t5}><CarouselContent>{t6}</CarouselContent></Carousel>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== api || $[11] !== canScrollNext || $[12] !== canScrollPrev || $[13] !== count || $[14] !== current) {
    t8 = count > 1 && <div className="flex items-center justify-center gap-1.5 pt-2"><button onClick={() => api?.scrollPrev()} className="border-border bg-background text-foreground hover:bg-muted hover:text-muted-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors disabled:pointer-events-none disabled:opacity-50" disabled={!canScrollPrev} aria-label="Previous slide"><ChevronLeftIcon className="h-4 w-4" /></button><SliderPagination current={current} count={count} onChange={i => api?.scrollTo(i)} /><button onClick={() => api?.scrollNext()} className="border-border bg-background text-foreground hover:bg-muted hover:text-muted-foreground flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors disabled:pointer-events-none disabled:opacity-50" disabled={!canScrollNext} aria-label="Next slide"><ChevronRightIcon className="h-4 w-4" /></button></div>;
    $[10] = api;
    $[11] = canScrollNext;
    $[12] = canScrollPrev;
    $[13] = count;
    $[14] = current;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div>{t8}</div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <div>{t7}{t9}</div>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
function _temp(blog) {
  return <CarouselItem key={blog.id} className="basis-full md:basis-1/2 lg:basis-1/3"><div className="h-full p-1"><BlogCard title={blog.title} slug={`${process.env.NEXT_PUBLIC_APP_URL}/blog/${blog.slug}`} coverSrc={blog.feature_image.medium} description={blog.content} author={blog.author} date={formatBlogDate(blog.created_on)} category={blog.category} /></div></CarouselItem>;
}